import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import AppProviders from "./AppProviders";
import GoogleAnalyticsRouteTracker from "./Components/GoogleAnalyticsRouteTracker";
import { InitialDataProvider } from "./SSR/InitialDataContext";
import { createAppStore } from "./store/Store";
import "./index.css";

const rootElement = document.getElementById("root");
const initialData = window.__INITIAL_DATA__ || {};
const store = createAppStore(initialData.preloadedState);

const app = (
  <BrowserRouter>
    <InitialDataProvider initialData={initialData}>
      <AppProviders store={store}>
        <GoogleAnalyticsRouteTracker />
        <App />
      </AppProviders>
    </InitialDataProvider>
  </BrowserRouter>
);

export function startClientApp() {
  if (!rootElement) {
    return;
  }

  if (rootElement.hasChildNodes()) {
    hydrateRoot(rootElement, app);
    return;
  }

  createRoot(rootElement).render(app);
}
